import userLists from '@/store/userLists/admin';
import { get } from '@/utils/api';

const state = {
	active: false,
	loaded: false,
	sections: [],
	previousLocation: null,
	currentSection: null
};

const mutations = {
	SET_ACTIVE(state, isActive)
	{
		state.active = isActive;
	},
	SET_LOADED(state)
	{
		state.loaded = true;
	},
	SET_SECTIONS(state, sections)
	{
		state.sections = sections;
	},
	PREVIOUS_LOCATION(state, location)
	{
		state.previousLocation = location;
	},
	SET_CURRENT_SECTION(state, current)
	{
		state.currentSection = current;
	}
};

const actions = {
	setActive({ commit }, isActive)
	{
		commit('SET_ACTIVE', isActive);
	},
	async load({ dispatch, commit })
	{
		await Promise.all([dispatch('loadSections')]);
		commit('SET_LOADED');
	},
	async loadSections({ commit })
	{
		const { data } = await get('admin/sections');

		commit('SET_SECTIONS', data);
	},
	previousLocation({ commit }, location)
	{
		commit('PREVIOUS_LOCATION', location);
	},
	setCurrentSection({ commit }, current)
	{
		commit('SET_CURRENT_SECTION', current);
	}
};

const getters = {
	isActive: (state) => state.active,
	isLoaded: (state) => state.loaded,
	sections: (state) => state.sections,
	section: (state, getters) => (sectionName) => getters.sections.find((section) => section === sectionName),
	previousLocation: (state) => state.previousLocation,
	currentSection: (state) => state.currentSection
};

const modules = {
	userLists
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
	modules
};
